<template>
  <Teleport to="body">
    <div class="global-toast">
      <TransitionGroup
        tag="div"
        name="flip-list"
        class="toast-container"
        appear
      >
        <BaseToast
          v-for="toast in toasts"
          :key="toast.id"
          :message="toast.message"
          :error="toast.error"
          :duration="toast.duration"
          :onClose="
            () => {
              hide(toast.id)
            }
          "
        />
      </TransitionGroup>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
const { toasts, hide } = useToast()
</script>

<style lang="scss" scoped>
.global-toast {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 0;
  z-index: 5000;
  .toast-container {
    display: flex;
    flex-direction: column-reverse;
    align-items: center;
    pointer-events: none;
    .base-toast {
      margin-top: 10px;
      min-width: 50vw;
      transition:
        transform 0.2s ease-out,
        opacity 0.2s;
      pointer-events: initial;
    }
  }
}

.flip-list-leave-active {
  position: absolute;
}
.flip-list-enter-from,
.flip-list-leave-to {
  transform: translateY(-100%);
  opacity: 0;
}
</style>
